module.exports = __webpack_public_path__ + "static/media/title.51dc1904.svg";